<template>
  <wrap-container>
    <help-title title="Reintegro del pago" />

    <help-list-container>
      <help-list-item
        tituloLista="Si tenés saldo a favor en pesos en tu Tarjeta de Crédito, podés:"
      >
        Solicitar el reintegro de dicha suma, a través de la
        <strong>Banca Online</strong>, en la opción tarjetas de crédito, podrás
        ver tu saldo a favor en color verde y la siguiente leyenda
        <strong>"Tenés saldo a favor"</strong>, y la opción de pedir la
        devolución, el crédito se realizará en tu caja de ahorro en pesos.
        <br />
        Utilizarlo para abonar tu deuda en dólares. Para ello, deberás modificar
        el débito automático (para que no debite la totalidad) y dejar impago el
        importe equivalente al saldo acreedor en pesos.
        <br />
        Mantenerlo acreedor para cubrir próximos consumos
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import ContactLink from "@/components/core/ContactLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    ContactLink
  }
};
</script>
